import { useEffect, useState } from "react";
import api, { fmtDateTime } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Markdown } from "@/components/Markdown";

export function LegalSnapshotDialog({ version, onClose }) {
  const [snap, setSnap] = useState(null);
  const [err, setErr] = useState("");
  const [tab, setTab] = useState(0);
  useEffect(() => {
    if (version === null || version === undefined) return;
    setSnap(null); setErr(""); setTab(0);
    api.get(`/admin/legal-snapshots/${version}`).then(({ data }) => setSnap(data)).catch((e) => setErr(e.response?.data?.detail || "Snapshot not found"));
  }, [version]);
  const page = snap?.pages?.[tab];
  return (
    <Dialog open={version !== null && version !== undefined} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-h-[90vh] max-w-3xl overflow-y-auto rounded-2xl" data-testid="legal-snapshot-dialog">
        <DialogHeader>
          <DialogTitle>Legal v{version} — permanent snapshot</DialogTitle>
          <DialogDescription data-testid="legal-snapshot-meta">
            {snap ? `Saved ${fmtDateTime(snap.created_at)} · ${snap.admin}${snap.note ? ` · ${snap.note}` : ""}. Read-only — snapshots can't be edited or deleted.` : err || "Loading…"}
          </DialogDescription>
        </DialogHeader>
        {snap && (
          <>
            <div className="flex flex-wrap gap-1.5" data-testid="legal-snapshot-tabs">
              {snap.pages.map((p, i) => (
                <button key={p.page_key} type="button" onClick={() => setTab(i)} data-testid={`legal-snapshot-tab-${p.page_key}`}
                  className={`rounded-full px-3 py-1 text-xs font-semibold transition-colors ${i === tab ? "bg-primary text-white" : "bg-slate-100 text-slate-600 hover:bg-slate-200"}`}>{p.label}</button>
              ))}
            </div>
            <div className="rounded-xl border border-slate-200 bg-slate-50 p-4" data-testid="legal-snapshot-page">
              <p className="font-heading font-semibold text-slate-900">{page.page_title}</p>
              {page.last_updated && <p className="mb-2 text-xs text-slate-400">Page last updated {fmtDateTime(page.last_updated)}</p>}
              <div className="text-sm" data-testid="legal-snapshot-content">{page.content ? <Markdown text={page.content} /> : <p className="text-slate-400">(This page had no content at the time.)</p>}</div>
            </div>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
}
